/**
 * LOG utitlities
 */

/**
 * MAP an object to its "live view"
 * @param obj 
 * @returns  string
 */

export function inspect(obj: unknown): string {
    const seen = new WeakSet<object>()
  
    function _inspect(value: unknown): string {
      // Primitives
      if (value === null) return 'null'
      if (typeof value === 'string') return `"${value}"`
      if (
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        typeof value === 'undefined'
      ) {
        return String(value)
      }
      if (typeof value === 'symbol') return (value as symbol).toString()
      if (typeof value === 'bigint') return `${(value as bigint).toString()}n`
  
      // Functions
      if (typeof value === 'function') {
        const fn = value as Function
        return `[Function${fn.name ? `: ${fn.name}` : ''}]`
      }
  
      // Objects and circular refs
      if (typeof value === 'object') {
        const vObj = value as object
        if (seen.has(vObj)) return '[Circular]'
        seen.add(vObj)
  
        if (Array.isArray(value)) {
          const items = (value as unknown[]).map(_inspect)
          return `[ ${items.join(', ')} ]`
        }
        if (value instanceof Date) {
          return (value as Date).toISOString()
        }
        if (value instanceof RegExp) {
          return (value as RegExp).toString()
        }
        if (value instanceof Error) {
          const err = value as Error
          return `${err.name}: ${err.message}`
        }
        if (value instanceof Map) {
          const entries = Array.from((value as Map<unknown, unknown>).entries()).map(
            ([k, v]) => `${_inspect(k)} => ${_inspect(v)}`
          )
          return `Map { ${entries.join(', ')} }`
        }
        if (value instanceof Set) {
          const items = Array.from((value as Set<unknown>).values()).map(_inspect)
          return `Set { ${items.join(', ')} }`
        }
        if (value instanceof Element) {
          const el = value as Element
          const tag = el.tagName.toLowerCase()
          const id = el.id ? ` id=\"${el.id}\"` : ''
          const cls = el.className ? ` class=\"${el.className}\"` : ''
          return `<${tag}${id}${cls}>`
        }
  
        // Plain object
        const keys = Object.keys(value as Record<string, unknown>)
        const props = keys.map(key => {
          let v: string
          try {
            v = _inspect((value as Record<string, unknown>)[key])
          } catch {
            v = '[Unable to serialize]'
          }
          return `${key}: ${v}`
        })
        return `{ ${props.join(', ')} }`
      }
  
      // Fallback for any other cases
      return String(value)
    }
  
    return _inspect(obj)
  }